export const getHeading = (value: string) => {
    switch (value) {
      case 'h1':
        return 'H1'
      case 'h2':
        return 'H2'
      case 'h3':
        return 'H3'
      case 'h4':
        return 'H4'
      case 'h5':
        return 'H5'
      case 'h6':
        return 'H6'
    default:
        return 'h2'
    }
  }
  